import { render, staticRenderFns } from "./TVShowSettings.vue?vue&type=template&id=2518d959&scoped=true&"
import script from "./TVShowSettings.vue?vue&type=script&lang=js&"
export * from "./TVShowSettings.vue?vue&type=script&lang=js&"
import style0 from "./TVShowSettings.vue?vue&type=style&index=0&id=2518d959&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2518d959",
  null
  
)

export default component.exports